import React from 'react';

import PillSegmented, {
  type PillSegmentedOption,
} from 'components/common/PillSegmented/PillSegmented';
import {
  PLAN_ACTUAL_ACTUAL_LABEL,
  PLAN_ACTUAL_PLAN_LABEL,
} from 'constants/uiConstants';
import { InputTaskCategory } from 'interfaces/IInputTask';

interface PlanActualSegmentedProps {
  value: InputTaskCategory;
  onChange: (category: InputTaskCategory) => void;
  className?: string;
}

const PLAN_ACTUAL_OPTIONS: PillSegmentedOption<InputTaskCategory>[] = [
  { label: PLAN_ACTUAL_PLAN_LABEL, value: InputTaskCategory.Plan },
  { label: PLAN_ACTUAL_ACTUAL_LABEL, value: InputTaskCategory.Actual },
];

/** Shared Plan/Actual toggle (Tasks header, Right Panel); styling lives in PillSegmented. */
const PlanActualSegmented: React.FC<PlanActualSegmentedProps> = ({
  value,
  onChange,
  className,
}) => (
  <PillSegmented<InputTaskCategory>
    options={PLAN_ACTUAL_OPTIONS}
    value={value}
    onChange={onChange}
    className={className}
  />
);

export default PlanActualSegmented;
